import {
    css, Theme,
} from '@emotion/react'
import common from 'shared/styles'
import custom from 'shared/styles/custom.styles'

const styles = (theme: Theme) => {
    return {
        root: css`
            ${common.fullContainer};
            display: flex;
        `,
        main: css`
            ${custom.dashBoardRoot};
            display: flex;
            flex-grow: 1;
            align-items: center;
            justify-content: space-between;
            flex-direction: column;
        `,
        button: css`
            ${custom.button};
        `,
        context: css`
            width: 100%;
            padding-top: 60px;
            padding-bottom: 60px;
            flex-basis: 100%;
        `,
        buttons: css`
            flex-basis: 60px;
            flex-grow: 0;
            flex-shrink: 0;
            align-items: flex-end;
        `,
        filter: css`
            display: flex;
            width: 100%;
            flex-basis: 60px;
            flex-grow: 0;
            flex-shrink: 0;
        `,
        selectedToggleButton: css`
            && {
                background-color: transparent;
                border-bottom: solid 2px ${theme.palette.primary.main};
                border-top: solid 2px ${theme.palette.primary.main};
            }
            &&:hover {
                background-color: transparent;
            }
        `,
        toggleButton: css`
            &&:hover {
                background-color: transparent;
            }
            &&:disabled {
                background-color: ${theme.palette.secondary[200]};
                opacity: 0.5;
            }
        `,
    }
}

export default styles
